module.exports = __webpack_public_path__ + "static/media/A2_19.6723140c.png";